import React from "react"
import Slider from "react-slick"
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import MasterCard from "../images/master_card.png"
import CsrHub from "../images/csr_hub.png"
import SiaranPers from "../images/pers.png"
import { useTranslation } from "react-i18next"

const slickContents = [
  {
    image: MasterCard,
    alt: "Master Card",
    title: "Mastercard Academy",
    body: "masterCard",
    to:
      "https://ekbis.sindonews.com/berita/1467543/178/mastercard-academy-20-dirancang-ciptakan-sdm-kompeten-di-era-digital",
  },
  {
    image: CsrHub,
    alt: "CSR Hub",
    title: "CSR Hub",
    body: "csr",
    to:
      "https://inforial.tempo.co/info/1002416/pemprov-jabar-gandeng-yayasan-infradigital-nusantara",
  },
  {
    image: SiaranPers,
    alt: "Cyber Security Training",
    title: "Cyber Security Training",
    body: "pers",
    to:
      "https://mediaindonesia.com/read/detail/319920-infradigital-gelar-cyber-security-training-bagi-6000-siswa-smk.html",
  },
]

const settings = {
  className: "slider variable-width",
  // dots: true,
  infinite: false,
  centerMode: false,
  slidesToShow: 1,
  slidesToScroll: 1,
  variableWidth: true,
  dragGable: true,
  arrows: true,
  focus: false,
}

export default function () {
  const { t } = useTranslation()
  return (
    <Slider {...settings}>
      {slickContents.map((item, i) => (
        <div key={item.title} className="slick-card mt-5">
          <div className="slick-card-img shadow-sm" key={i}>
            <img src={item.image} alt={item.alt} loading="lazy"></img>
          </div>
          <div className="slick-card-body d-flex">
            <div className="card-content">
              <h6 className="sub-title">{item.title}</h6>
              <p className="description">{t(item.body)}</p>
            </div>
            <div className="card-btn">
              <a
                href={item.to}
                target="_blank"
                rel="noreferrer"
                className="main-btn"
              >
                {t("bButton")}
              </a>
            </div>
          </div>
        </div>
      ))}
    </Slider>
  )
}
